import * as cuBuilding from "../../../redux/reducers/building_pricing/pricingReducer";
import * as utils from "../../../redux/reducers/utils";
import { makeDimensionArray } from "./centreBuilding.helper";
import { const_var, params } from "../../../redux/reducers/reducer";
import { getBuildingColor } from "../building_color/building.color.helper";
import { initBuildingSidingMaterialOptions } from "../building_material/buildingMaterial.helper";
import { setIntelDefaultBuilding } from "../../../Intel/defaultBuilding/defaultbuilding.helper";
import { setWainscotDefault } from "../building_color/wainscotColor.helper";
const setBuildingData = (state, resData, flag, completeResponse, reducerFns = {}) => {
	const { makeDimensionUpdateBack, makeDimensionUpdateFront, makeDimensionUpdateLeft, makeDimensionUpdateRight } = reducerFns;
	state.const_var.SendAPIBuildingData = completeResponse.newBuildingData;
	getBuildingColor(state, completeResponse.newBuildingColor);
	const buildingData = completeResponse.newBuildingData.building || []; 
	const_var.regionId = [];
	if (buildingData && Array.isArray(buildingData)) {
		state.c_m_a = state.c_m_a_new || [];
		state.const_var.b_o_J_1 = state.const_var.b_o_J_1 || [];
		state.const_var.Map_Id = state.const_var.Map_Id || [];
		state.const_var.ConditionArr = state.const_var.ConditionArr || [];
		state.const_var.BarnConditionArr = state.const_var.BarnConditionArr || [];
		state.const_var.DistanceArr = state.const_var.DistanceArr || [];
		state.const_var.roofObject = state.const_var.roofObject || [];
		state.const_var.TypeEnumID = state.const_var.TypeEnumID || [];
		let dimensionString = "";
		for (let i = 0; i < completeResponse.newBuildingData.building.length; i++) {
			const defaultBuildingID = parseInt(completeResponse.newBuildingData.building[i].building_type.default_building);
			if (const_var?.is_intel) {
				const_var.UniqueDefaultBuildingId = defaultBuildingID;
			}
			state.c_m_a[defaultBuildingID] = new Array();
			state.c_m_a[defaultBuildingID].uniqueBuildingId    = completeResponse.newBuildingData.building[i].building_type.building_id;
			state.c_m_a[defaultBuildingID].uniquePriceBookId   = completeResponse.newBuildingData.building[i].building_type.price_book_id;
			state.c_m_a[defaultBuildingID].uniqueLeanId        = completeResponse.newBuildingData.building[i].building_type.lean_to_building_ids?.[0];
			state.c_m_a[defaultBuildingID].defaultBuldingcheck = completeResponse.newBuildingData.building[i].building_type.type_of_building;
			state.const_var.b_o_J_1[defaultBuildingID] = completeResponse.newBuildingData.building[i].building_type.name;
			if (completeResponse.newBuildingData.building[i].fixed_width != undefined && completeResponse.newBuildingData.building[i].fixed_width.length > 0) {
				state.c_m_a[defaultBuildingID].fixed_new_leg_width = completeResponse.newBuildingData.building[i].fixed_width;
			}
			if (completeResponse && completeResponse.newBuildingMaterial) {
				state.c_m_a[defaultBuildingID].side_end_details = completeResponse.newBuildingMaterial;
			}
			state.c_m_a[defaultBuildingID]["wainscot_details"] = [];
			state.c_m_a[defaultBuildingID].roof_style = buildingData[i].building_variations;
			state.const_var.ConditionArr[defaultBuildingID] = [];
			state.const_var.BarnConditionArr[defaultBuildingID] = [];
			state.const_var.DistanceArr[defaultBuildingID] = [];
			state.const_var.roofObject[defaultBuildingID] = [];
			const variations = buildingData?.[i]?.building_variations;
			if (!Array.isArray(variations) || variations.length === 0) {
				continue;
			}
			for (let j = 0; j < buildingData[i].building_variations.length; j++) {
				buildingData[i].building_variations[j].roof_id = Number(buildingData[i].building_variations[j].roof_id);
				if (const_var?.is_intel) {
					params.p_b_t = defaultBuildingID;
				}
				params.p_r_s = buildingData[i].building_variations[j].roof_id;
				if (
					Object.keys(completeResponse.newBuildingData.building[i].building_variations[j].conditions).length > 0 &&
					completeResponse.newBuildingData.building[i].building_variations[j].conditions.Bows_Trusses_condition != undefined
				) {
					completeResponse.newBuildingData.building[i].building_variations[j].conditions.Bows_Trusses_condition[0].name.trim();
				}
				state.c_m_a[defaultBuildingID].trussType =
					Object.keys(completeResponse.newBuildingData.building[i].building_variations[j].conditions).length > 0 &&
					completeResponse.newBuildingData.building[i].building_variations[j].conditions.Bows_Trusses_condition != undefined
						? completeResponse.newBuildingData.building[i].building_variations[j].conditions.Bows_Trusses_condition
						: {};

				state.params.frame_length =
					completeResponse.newBuildingData.building[i].building_variations[j].roof_length != undefined ? completeResponse.newBuildingData.building[i].building_variations[j].roof_length : 0;
				state.const_var.DistanceArr[defaultBuildingID][completeResponse.newBuildingData.building[i].building_variations[j].roof_id] =
					params.fourth_center_cost != true ? parseInt(completeResponse.newBuildingData.building[i].building_variations[j].distance_on_center) : 4;
				if (Object.keys(completeResponse.newBuildingData.building[i].building_variations[j].conditions).length !== 0) {
					state.const_var.ConditionArr[defaultBuildingID][completeResponse.newBuildingData.building[i].building_variations[j].roof_id] =
						Object.keys(completeResponse.newBuildingData.building[i].building_variations[j].conditions).length > 0 &&
						completeResponse.newBuildingData.building[i].building_variations[j].conditions.Bows_Trusses_condition != undefined
							? completeResponse.newBuildingData.building[i].building_variations[j].conditions.Bows_Trusses_condition
							: [];
				}
				state.const_var.TypeEnumID[completeResponse.newBuildingData.building[i].building_variations[j].roof_id] = completeResponse.newBuildingData.building[i].building_variations[j].name;
				state.const_var.roofObject[defaultBuildingID][completeResponse.newBuildingData.building[i].building_variations[j].roof_id] = completeResponse.newBuildingData.building[i].building_variations[j];
				state.defaultBuilding = 1;
				dimensionString = `${completeResponse.newBuildingData.building[i].building_variations[j].min_width}x${completeResponse.newBuildingData.building[i].building_variations[j].start_length}x${completeResponse.newBuildingData.building[i].building_variations[j].start_height}`;
				let building_name = completeResponse.newBuildingData.building[i].building_type.name;
				if (const_var?.is_intel) {
					setIntelDefaultBuilding({
						const_var,
						defaultBuildingID,
						completeResponse,
						state,
						params,
						dimensionString,
						building_name
					});
				}
			}
		}
	}
	document.querySelector("body").classList.remove("active-modal-loader");
	if (!const_var.isFromPickThis && state.c_m_a[params.p_b_t]?.wainscot_details?.length > 0) {
	setWainscotDefault(state.c_m_a, params, state.const_var.color);
	}
	state.const_var.building = completeResponse.newBuildingData?.building;
	state.const_var.roof_style = state.c_m_a[state.params.p_b_t].roof_style;
	cuBuilding.makeInsulationArrayForLeanto();
	state.const_var.selectedBuilding = completeResponse.newBuildingData?.building[0];
	state.b_m_i_w = state.c_m_a[state.params.p_b_t];
	state.const_var.c_m_a = state.c_m_a;
	cuBuilding.uUdD();
	cuBuilding.uUdDCB();
	cuBuilding.leanuUdD();
	utils.makeSidingOptions();
	makeDimensionArray(state);
	makeDimensionUpdateRight(state);
	makeDimensionUpdateLeft(state);
	makeDimensionUpdateFront(state);
	makeDimensionUpdateBack(state);
	cuBuilding.CheckLegsByResponse(state);
	cuBuilding.BuildingUpdate(true);
	cuBuilding.UpdateFrontLean();
	cuBuilding.UpdateLeftLean();
	cuBuilding.UpdateRightLean();
	cuBuilding.UpdateBackLean();
	if (!const_var.crmSetting.is_Edit) cuBuilding.CheckLeanLegsByResponse(state, "all");
	const_var.eventKey = "carports";
};

export default setBuildingData;
